import { Trans, useLingui } from '@lingui/react/macro';
import { isMatchPeriodsSettingsMissing } from 'modules/overlay-v2/domain/utils/is-match-periods-settings-missing';
import { syncGameInfo } from 'modules/overlay-v2/store/game-info/actions';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from 'store/store';
import { useDispatchWithToast } from 'store/use-dispatch-with-toast';
import { MISSING_PERIODS_SETTINGS_TOAST } from 'modules/overlay-v2/ui/constants/missing-periods-settings-toast';
import UDButton from 'ud-ui/components/button';
import { selectPopupIsLoaded } from 'modules/overlay-v2/store/overlay/selectors';
import { syncTime } from 'modules/overlay-v2/store/time/actions';
import { selectTime } from 'modules/overlay-v2/store/time/selectors';
import useGameInfo from 'modules/overlay-v2/ui/hooks/use-game-info';
import usePopupMessenger from 'modules/overlay-v2/ui/hooks/use-popup-messenger';
import useTimer from 'modules/overlay-v2/ui/hooks/use-timer';

function SyncStateButton() {
  const { t } = useLingui();
  const dispatch = useDispatch<AppDispatch>();
  const dispatchWithToast = useDispatchWithToast();
  const { match, isSynchronization } = useGameInfo();
  const [prevStateSynchonization, setPrevStateSynchonization] = useState(false);

  const { hasPopups, send } = usePopupMessenger();
  const popupIsLoaded = useSelector(selectPopupIsLoaded);
  const gameInfo = useGameInfo();
  const time = useSelector(selectTime);
  const { timer } = useTimer();

  const handleClickSync = useCallback(() => {
    if (isSynchronization) return;
    if (!match) return;
    const matchId = match.id;
    dispatchWithToast(syncGameInfo({ matchId }), {
      error: (error) => (isMatchPeriodsSettingsMissing(error) ? t(MISSING_PERIODS_SETTINGS_TOAST.message) : undefined),
      errorOptions: MISSING_PERIODS_SETTINGS_TOAST.options,
    });
    dispatch(syncTime({ matchId }));
  }, [dispatch, dispatchWithToast, isSynchronization, match, t]);

  useEffect(() => {
    // Данные пришли с сервера (синхронизация только что закончилась) — раздаём их окнам.
    if (prevStateSynchonization && popupIsLoaded && hasPopups) {
      send({ type: 'syncState', time, timer, gameInfo });
    }

    setPrevStateSynchonization(isSynchronization);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSynchronization]);

  return (
    <UDButton disabled={isSynchronization} onClick={handleClickSync} loading={isSynchronization} variant={'dark'}>
      <Trans>Синхронизировать состояние</Trans>
    </UDButton>
  );
}

export default SyncStateButton;
